const mEditionBillingSalesDataCreateData = {
  mEditionBillingSalesDataCreateData: {
    alerts: {
      createPuntoVenta: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El punto de venta fue creado exitosamente.'
      }
    },

    buttonPrimary: 'CREAR',

    fieldsets: {
      legends: {
        contact: 'Información de Contacto',
        general: 'Información General',
        invoice: 'Información de Comprobante',
        legal: 'Información Legal',
        location: 'Información de Ubicación'
      }
    },

    inputs: {
      persona: {
        codigo_postal: {
          label: 'Código Postal',
          message: '* De 1 a 10 caracteres'
        },

        documento_numero: {
          label: 'Número de Documento',
          message: '* De 1 a 45 caracteres'
        },

        documento_tipo: {
          label: 'Tipo de Documento',
          message: '* Primero debes seleccionar un país'
        },

        fisica: {
          label: 'Tipo de Persona'
        },

        linea1: {
          label: 'Dirección Principal',
          message: '* De 1 a 120 caracteres'
        },

        linea2: {
          label: 'Dirección Opcional',
          message: 'De 1 a 120 caracteres'
        },

        localidad: {
          label: 'Localidad',
          message: '* De 1 a 60 caracteres'
        },

        movil: {
          label: 'Número de Móvil',
          message: '* De 1 a 60 caracteres'
        },

        pais: {
          label: 'País'
        },

        provincia: {
          label: 'Provincia',
          message: '* Primero debes seleccionar un país'
        },

        razon_social: {
          labelBusiness: 'Razón Social',
          labelName: 'Nombre',
          message: '* De 1 a 60 caracteres'
        },

        telefono: {
          label: 'Número de Teléfono',
          message: '* De 1 a 60 caracteres'
        }
      },

      punto_venta: {
        comprobante_tipo: {
          label: 'Tipo de Comprobante',
          message: '* Primero debes seleccionar un país'
        },

        divisa: {
          label: 'Moneda (divisa)'
        },

        divisa_emite: {
          label: 'Emite (divisa)'
        },

        divisa_vende: {
          label: 'Vende (divisa)'
        },

        mensaje_pie: {
          label: 'Nota Legal',
          message: '* De 1 a 255 caracteres'
        },

        nombre: {
          label: 'Nombre de Punto de Venta',
          placeholder: 'Mi Punto de Venta',
          message: '* De 1 a 60 caracteres'
        },

        numero: {
          label: 'Código Inicial',
          message: '* De 1 a 10 caracteres',
          tooltip: 'El sistema generará la numeración de cada comprobante colocando el año actual y el número incremental luego del código inicial que introduzcas. Ej: "ABC-2021-00"'
        }
      }
    },

    title: 'CREAR PUNTO DE VENTA',

    validation: {
      persona: {
        codigo_postal: {
          maxLength: 'La longitud máxima permitida es de 10 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Código Postal es requerido.'
        },

        documento_numero: {
          maxLength: 'La longitud máxima permitida es de 45 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de Documento es requerido.'
        },

        documento_tipo: {
          required: 'Tipo de Documento es requerido. Primero debes seleccionar un país.'
        },

        fisica: {
          required: 'Tipo de Persona es requerida.'
        },

        linea1: {
          maxLength: 'La longitud máxima permitida es de 120 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Primera línea de dirección es requerida.'
        },

        linea2: {
          maxLength: 'La longitud máxima permitida es de 120 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.'
        },

        localidad: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Localidad es requerida.'
        },

        movil: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de móvil es requerido.'
        },

        pais: {
          required: 'País es requerido.'
        },

        provincia: {
          required: 'Provincia es requerida. Primero debes seleccionar un país.'
        },

        razon_social: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Dato requerido.'
        },

        telefono: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de teléfono es requerido.'
        }
      },

      punto_venta: {
        comprobante_tipo: {
          required: 'Tipo de Comprobante es requerido. Primero debes seleccionar un país.'
        },

        divisa: {
          required: 'Moneda (divisa) es requerida.'
        },

        mensaje_pie: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Nota Legal es requerida.'
        },

        nombre: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Nombre de punto de venta es requerido.'
        },

        numero: {
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          maxLength: 'La longitud máxima permitida es de 10 caracteres.',
          required: 'Código Inicial de punto de venta es requerido.'
        }
      }
    }
  }
}

export default mEditionBillingSalesDataCreateData
